import {useCurrency as useBaseCurrency} from '../../nuxt-base/composables/useCurrency.js';
import {formatCurrencyAmount} from '../utils/currencyAmount.mjs';

export function useCurrency() {
	const base = useBaseCurrency();
	const {formatPrice} = useText();
	function formatCurrency(value, options = {}) {
		const parsed = formatPrice(value);
		const locale = options.locale || 'hr-HR';
		const amount = formatCurrencyAmount(parsed, locale);
		const fullAmount = new Intl.NumberFormat(locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(parsed);
		if (amount === fullAmount) return base.formatCurrency(value, options);
		const displayAmount = options.wrap ? `<span class="p p-h">${amount}</span>` : amount;
		return base.formatCurrency(value, {...options, wrap: false}).replace(fullAmount, displayAmount);
	}
	return {...base, formatCurrency};
}
